import { InjectionToken } from '@angular/core';
import { TableToolbarActionInterface } from './table-toolbar-action.interface';

/**
 * The channel a table capability contributes its toolbar control through. A capability directive provides
 * itself under this token — `multi`, so several capabilities on one table each get their control:
 *
 * ```ts
 * providers: [{ provide: TABLE_TOOLBAR_ACTION, useExisting: forwardRef(() => MyDirective), multi: true }]
 * ```
 *
 * The table reads the token off its own element injector, so only capabilities attached to that table
 * contribute to it.
 */
export const TABLE_TOOLBAR_ACTION = new InjectionToken<TableToolbarActionInterface[]>('TableToolbarAction');
